import { CASH_RECEIPTS } from '../actionTypes';

export const fetchCashReceipts = (action) => ({
  type: CASH_RECEIPTS.FETCH,
  payload: action.payload,
});
